import { Injectable } from '@angular/core';
import { NbToastrService, NbGlobalLogicalPosition } from '@nebular/theme';
import { NbToastStatus } from '@nebular/theme/components/toastr/model';

@Injectable()
export class ToastrService {

    constructor(private toastrService: NbToastrService) { }

    showSuccess(message: string) {

        const config = {
            status: NbToastStatus.SUCCESS,
            destroyByClick: true,
            duration: 2000,
            hasIcon: false,
            position: NbGlobalLogicalPosition.TOP_END,
            preventDuplicates: true,
        };

        this.toastrService.show(message, null, config);
    }
    showError(message: string) {

        const config = {
            status: NbToastStatus.DANGER,
            destroyByClick: true,
            duration: 5000,
            hasIcon: false,
            position: NbGlobalLogicalPosition.TOP_END,
            // preventDuplicates: true,
        };

        this.toastrService.show(message, "Erro", config);
    }

    showInfo(message: string) {

      const config = {
          status: NbToastStatus.INFO,
          destroyByClick: true,
          duration: 5000,
          hasIcon: false,
          position: NbGlobalLogicalPosition.TOP_END,
          // preventDuplicates: true,
      };

      this.toastrService.show(message, "Info", config);
  }
}
